/* =========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
import { messages } from './main'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login-session',
          component: () => import('@/views/pages/Login.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/menu',
          name: 'devices-menu',
          component: () => import('./views/pages/DevicesMenu.vue')
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard.vue')
        },
        // Device example//
        {
          path: '/agro',
          name: 'agro',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAgro', active: true }
            ],
            pageTitle: 'DashboardAgro'
          }
        },
        {
          path: '/agro/detail/:uuid',
          name: 'agro-detail',
          component: () => import('./views/pages/Agro/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAgro', url: '/agro' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/agro/config/:uuid',
          name: 'agro-config',
          component: () => import('./views/pages/Agro/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAgro', url: '/agro' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/agro/statistics/:uuid',
          component: () => import('./views/pages/Agro/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAgro', url: '/agro' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        // End Device example//
        // Users//
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/pages/Users/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'UsersList', active: true }
            ],
            pageTitle: 'UsersList',
            rule: 'admin'
          }
        },
        {
          path: '/create-user',
          name: 'Create User',
          component: () => import('./views/pages/Users/Create.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'UserCreate', active: true }
            ],
            pageTitle: 'UserCreate',
            rule: 'admin'
          }
        },
        {
          path: '/edit-user/:uuid',
          name: 'Edit User',
          component: () => import('./views/pages/Users/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'UserEdit', active: true }
            ],
            pageTitle: 'UserEdit',
            rule: 'admin'
          }
        },
        // End Users//
        /// ////////////////// Map ///////////////////////////////
        {
          path: '/map',
          component: () => import('./views/pages/GeneralMap.vue'),
          meta: {
            breadcrumb: [{ title: 'GeneralMap', url: '/map', active: true }],
            pageTitle: 'GeneralMap'
          }
        },
        /// ////////////////// Map END ///////////////////////////////
        // Airflow
        {
          path: '/airflow',
          name: 'airflow',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAirflow', active: true }
            ],
            pageTitle: 'DashboardAirflow'
          }
        },
        {
          path: '/airflow/detail/:uuid',
          component: () => import('./views/pages/AirFlow/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAirflow', url: '/airflow' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/airflow/costs',
          component: () => import('./views/pages/AirFlow/Costs.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAirFlow', url: '/airflow' },
              { title: 'CostConfigurations', active: true }
            ],
            pageTitle: 'CostConfigurations',
            rule: 'admin'
          }
        },
        {
          path: '/airflow/config/:uuid',
          component: () => import('./views/pages/AirFlow/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAirflow', url: '/airflow' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/airflow/statistics/:uuid',
          component: () => import('./views/pages/AirFlow/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardAirflow', url: '/airflow' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        // Airflow END///
        // Doors
        {
          path: '/doors',
          name: 'doors',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardDoors', active: true }
            ],
            pageTitle: 'DashboardDoors'
          }
        },
        {
          path: '/doors/detail/:uuid',
          component: () => import('./views/pages/Doors/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardDoors', url: '/doors' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/doors/config/:uuid',
          component: () => import('./views/pages/Doors/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardDoors', url: '/doors' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/doors/statistics/:uuid',
          component: () => import('./views/pages/Doors/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardDoors', url: '/doors' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        // Doors END///
        // Environment Temperature
        {
          path: '/env',
          name: 'env',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnv', active: true }
            ],
            pageTitle: 'DashboardEnv'
          }
        },
        {
          path: '/env/detail/:uuid',
          component: () => import('./views/pages/EnvTemp/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnv', url: '/env' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/env/config/:uuid',
          component: () => import('./views/pages/EnvTemp/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnv', url: '/env' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/env/statistics/:uuid',
          component: () => import('./views/pages/EnvTemp/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnv', url: '/env' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        // Env END///
        // Energies
        {
          path: '/energy',
          name: 'energy',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnergy', active: true }
            ],
            pageTitle: 'DashboardEnergy'
          }
        },
        {
          path: '/energy/detail/:uuid',
          component: () => import('./views/pages/Energy/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnergy', url: '/energy' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo',
            rule: 'editor'
          }
        },
        {
          path: '/energy/costs',
          component: () => import('./views/pages/Energy/Costs.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnergy', url: '/energy' },
              { title: 'CostConfigurations', active: true }
            ],
            pageTitle: 'CostConfigurations',
            rule: 'admin'
          }
        },
        {
          path: '/energy/config/:uuid',
          component: () => import('./views/pages/Energy/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnergy', url: '/energy' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/energy/statistics/:uuid',
          component: () => import('./views/pages/Energy/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardEnergy', url: '/energy' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        // Energies END///
        /// ////////////////// SmartLabels /////////////////////////////////
        {
          path: '/labels',
          name: 'labels',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardLabels', active: true }
            ],
            pageTitle: 'DashboardLabels'
          }
        },
        {
          path: '/labels/assign/:uuid',
          component: () => import('./views/pages/SmartLabels/Assign.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardLabels', url: '/labels' },
              { title: 'Assign', active: true }
            ],
            pageTitle: 'Assign',
            rule: 'admin'
          }
        },
        {
          path: '/labels/detail/:uuid/',
          component: () => import('./views/pages/SmartLabels/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardLabels', url: '/labels' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/labels/config/:uuid',
          component: () => import('./views/pages/SmartLabels/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'DashboardLabels', url: '/labels' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        }
        // SmartLabels END///
      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.AppActiveUser.token.length > 0) {
    if (to.path === '/' || to.path === '/forgot-password' || (store.state.AppActiveUser.userRole !== 'MA' && to.matched.some(record => record.meta.rule === 'admin'))) {
      window.location.href = '/menu'
    } else {
      messages().then(() => next())
    }
  } else if (to.path === '/' || to.path === '/forgot-password') {
    messages().then(() => next())
  } else {
    window.location.href = '/'
  }
})

export default router
